"use client";

import { c as _c } from "react/compiler-runtime";
import { ReferralAuthInstructionsCard } from "@/src/components/tasks/referral-auth-instructions-card";
import { StediEligibilitySummary } from "@/src/components/tasks/stedi-eligibility-summary";
import { useReferralAuthOpenAuthorization } from "@/src/hooks/use-referral-auth-open-authorization";
import { deriveReferralAuthorizationFromStedi } from "@/src/lib/clearinghouse/stedi/derive-referral-authorization-from-stedi";
import { resolveStediEligibilityDisplay } from "@/src/lib/clearinghouse/stedi/extract-eligibility-summary";
import { useStediEligibilityCheck } from "@/src/lib/data-fetchers/stedi-eligibility-check-fetchers";
import { buildAutonomyReferralAuthInstruction, canStartReferralAuthTrackingCase, getReferralAuthTrackingCaseButtonTooltip } from "@/src/lib/prior-authorization/autonomy-referral-auth-instructions";
import { resolveReferralAuthOnFile } from "@/src/lib/prior-authorization/referral-auth-on-file";
import type { PriorAuthorization } from "@/src/models/documents/prior-authorization/prior-authorization";
import { Referral } from "@/src/models/documents/referral";
interface AutonomyReferralAuthInstructionsProps {
  referral: Referral;
  linkedPriorAuthorizations: PriorAuthorization[];
  taskId: string;
  taskPriorAuthorization?: PriorAuthorization | null;
  startTrackingCaseDisabled?: boolean;
}
export function AutonomyReferralAuthInstructions(t0) {
  const $ = _c(14);
  const {
    referral,
    linkedPriorAuthorizations,
    taskId,
    taskPriorAuthorization,
    startTrackingCaseDisabled: t1
  } = t0;
  const startTrackingCaseDisabled = t1 === undefined ? false : t1;
  const {
    eligibilityCheck,
    isLoading
  } = useStediEligibilityCheck(referral.id);
  const eligibilityDisplay = eligibilityCheck ? resolveStediEligibilityDisplay(eligibilityCheck) : null;
  const teStatus = eligibilityDisplay ? deriveReferralAuthorizationFromStedi(eligibilityDisplay.officeVisitRequiresAuth, eligibilityDisplay.checkFailed).teStatus : null;
  const authOnFile = resolveReferralAuthOnFile(referral, linkedPriorAuthorizations, taskPriorAuthorization);
  const canStartTrackingCase = canStartReferralAuthTrackingCase({
    isLoading,
    hasEligibilityCheck: !!eligibilityCheck,
    teStatus,
    planType: eligibilityDisplay?.planType ?? null
  });
  let t2;
  if ($[0] !== linkedPriorAuthorizations || $[1] !== taskId || $[2] !== taskPriorAuthorization) {
    t2 = {
      taskId,
      taskPriorAuthorization,
      linkedPriorAuthorizations
    };
    $[0] = linkedPriorAuthorizations;
    $[1] = taskId;
    $[2] = taskPriorAuthorization;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    handleOpenAuthorization,
    isOpeningAuthorization
  } = useReferralAuthOpenAuthorization(t2);
  const isButtonDisabled = startTrackingCaseDisabled || isOpeningAuthorization || !canStartTrackingCase;
  const openButtonTooltip = getReferralAuthTrackingCaseButtonTooltip({
    isLoading,
    hasEligibilityCheck: !!eligibilityCheck,
    teStatus,
    planType: eligibilityDisplay?.planType ?? null,
    isSubmitting: startTrackingCaseDisabled
  });
  const T0 = ReferralAuthInstructionsCard;
  const t3 = buildAutonomyReferralAuthInstruction({
    isLoading,
    hasEligibilityCheck: !!eligibilityCheck,
    teStatus,
    planType: eligibilityDisplay?.planType ?? null,
    authOnFile
  });
  let t4;
  if ($[4] !== eligibilityCheck) {
    t4 = eligibilityCheck ? <StediEligibilitySummary check={eligibilityCheck} /> : null;
    $[4] = eligibilityCheck;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== T0 || $[7] !== handleOpenAuthorization || $[8] !== isButtonDisabled || $[9] !== isOpeningAuthorization || $[10] !== openButtonTooltip || $[11] !== t3 || $[12] !== t4) {
    t5 = <T0 instruction={t3} openButtonTooltip={openButtonTooltip} isOpenButtonDisabled={isButtonDisabled} isOpening={isOpeningAuthorization} onOpenAuthorization={handleOpenAuthorization} footer={t4} />;
    $[6] = T0;
    $[7] = handleOpenAuthorization;
    $[8] = isButtonDisabled;
    $[9] = isOpeningAuthorization;
    $[10] = openButtonTooltip;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
}